<div class="modal-header">
  <h4 class="modal-title">Crear Usuario</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <form
          action=""
          [formGroup]="userForm"
          (ngSubmit)="actualizarUser()"
          class="form-horizontal form-material"
          id="userform"
          novalidate
        >
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="userForm.controls['username']"
                [controlName]="'Nombre de Usuario'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="username"
                  placeholder="Nombre de Usuario"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="userForm.controls['password']"
                [controlName]="'Contraseña'"
              >
                <input
                  class="form-control"
                  type="password"
                  formControlName="password"
                  placeholder="Contraseña"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="userForm.controls['email']"
                [controlName]="'Correo Electronico'"
              >
                <input
                  class="form-control"
                  type="email"
                  formControlName="email"
                  placeholder="Ejemplo@gmail.com"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="userForm.controls['nombres']"
                [controlName]="'Nombres'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="nombres"
                  placeholder="Nombres del Usuario"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="userForm.controls['apellidos']"
                [controlName]="'Apellidos'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="apellidos"
                  placeholder="Apellidos del Usuario "
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="userForm.controls['ci']"
                [controlName]="'ci'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="ci"
                  placeholder="C.I del Usuario "
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="userForm.controls['celular']"
                [controlName]="'celular'"
              >
                <label for="">Celular</label>
                <input
                  class="form-control"
                  type="text"
                  formControlName="celular"
                  placeholder="Celular"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group">
            <label for="options"><b>Roles:</b></label>
            <div *ngFor="let option of rols; index as i" class="row">
              <label>
                <label class="container"
                  >{{ option.name }}
                  <input
                    type="checkbox"
                    value="{{ option.id }}"
                    [checked]="option.enabled"
                    formControlName="role"
                    (change)="selectRoles($event, option.id)"
                  />
                  <span class="checkmark"></span>
                </label>
              </label>
              <!--End ngfor-->
            </div>
          </div>

          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="userForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Guardar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
  >
    Cerrar
  </button>
</div>
